import { Component, OnInit } from '@angular/core';
import { AppConstants } from 'src/app-constants';
import { CommonService } from 'src/app/services/common.service';
import { ContactSalesService } from 'src/app/services/contact-sales.service';
import { LogHandlerService } from 'src/app/services/log-handler.service';
import { ContactsalesViewModel } from 'src/app/view-models/contact-sales.viewmodel';
import { BaseComponent } from '../base.component';
// import {ContactSalesService} from 'src/app/services/contact-sales.service';
// import { ErrType } from 'src/app/viewModels/base-view-model';
// import { ContactSalesPageVM } from 'src/app/viewModels/contact-sales-vm';


@Component({
  selector: 'app-contact-sales',
  templateUrl: './contact-sales.component.html',
  styleUrls: ['./contact-sales.component.scss']
})
export class ContactSalesComponent extends BaseComponent<ContactsalesViewModel> implements OnInit {

  // showCompanyInfo: boolean = false;

  constructor(private contactSlaesService: ContactSalesService,
    commonService: CommonService, logService: LogHandlerService) {
    super(commonService, logService);
    this.viewModel = new ContactsalesViewModel();
  }

  ngOnInit(): void {

  }


  selected(e: any) {
    let x = e.srcElement.value;
    if (x == "company") {
      this.viewModel.showCompanyInfo = true;
    } else {
      this.viewModel.showCompanyInfo = false;
    }
    return
  }
  async contactSalesForm() {
    try {
      await this._commonService.presentLoading();
      //have to do paging
      let resp = await this.contactSlaesService.contactSales(this.viewModel.singleContactSales);
      if (resp.isError) {
        this._exceptionHandler.logObject(resp.errorData);
        this._commonService.presentToast({
          header: 'Error!',
          body: resp.errorData.displayMessage, delay: 5000,
          className: 'TopRight bg-danger text-light', animation: true
        });
      }
      else {
        if (resp.successData != null)
          this.viewModel.singleContactSales = resp.successData;
      }
    } catch (error) {
      this._commonService.presentToast({
        header: 'Error!',
        body: AppConstants.ErrorPrompts.Unknown_Error, delay: 5000,
        className: 'TopRight bg-danger text-light', animation: true
      });
      throw error;
    }
    finally {
      await this._commonService.dismissLoader()
    }
  }

}


